<template>
    <div>
        <b-container fluid>
            <h2>
                Informació global
            </h2>
            <h4>
                <b-badge v-show="averagesLoaded && onWarningInterval" variant="success"
                         style="margin-right: 20px;">Activades alertes per franja horària
                </b-badge>
                <b-badge v-show="averagesLoaded && !onWarningInterval" variant="warning"
                         style="margin-right: 20px;">Desactivades alertes per franja horària
                </b-badge>
                <b-badge v-show="averagesLoaded && onPowerWarningValues" variant="success" style="margin-right: 20px;">
                    Activades alertes per llindar de potència ({{this.globalPowerAverage}}/{{this.minimumPowerAverage}})
                </b-badge>
                <b-badge v-show="averagesLoaded && !onPowerWarningValues" variant="warning" style="margin-right: 20px;">
                    Desactivades alertes per llindar de potència ({{this.globalPowerAverage}}/{{this.minimumPowerAverage}})
                </b-badge>
            </h4>
            <b-row>
                <b-col>
                    <b-card bg-variant="primary" text-variant="white" header="Seguidors 6.75kW"
                            class="text-left">
                        <b-card-text>
                            <b-spinner label="Consultant" v-show="this.$store.state.loadingAverages"></b-spinner>
                            <div v-show="!this.$store.state.loadingAverages">
                                P1: {{ this.powerLowP1 }}<br/>
                                P2: {{ this.powerLowP2 }}<br/>
                                P3: {{ this.powerLowP3 }}<br/>
                            </div>
                        </b-card-text>
                    </b-card>
                </b-col>
                <b-col>
                    <b-card bg-variant="primary" text-variant="white" header="Seguidors 9kW"
                            class="text-left">
                        <b-card-text>
                            <b-spinner label="Consultant" v-show="this.$store.state.loadingAverages"></b-spinner>
                            <div v-show="!this.$store.state.loadingAverages">
                                P1: {{ this.powerHighP1 }}<br/>
                                P2: {{ this.powerHighP2 }}<br/>
                                P3: {{ this.powerHighP3 }}<br/>
                            </div>
                        </b-card-text>
                    </b-card>
                </b-col>
                <b-col>
                    <b-card bg-variant="primary" text-variant="white" header="EppcPosition" class="text-left">
                        <b-card-text>
                            <b-spinner label="Consultant" v-show="this.$store.state.loadingAverages"></b-spinner>
                            <div v-show="!this.$store.state.loadingAverages">
                                Azimut: {{ this.positionEppcAzimut }}<br/>
                                Zenit: {{ this.positionEppcZenit }}<br/>
                            </div>
                        </b-card-text>
                    </b-card>
                </b-col>
                <b-col>
                    <b-card bg-variant="primary" text-variant="white" header="Modicon" class="text-left">
                        <b-card-text>
                            <b-spinner label="Consultant" v-show="this.$store.state.loadingAverages"></b-spinner>
                            <div v-show="!this.$store.state.loadingAverages">
                                Azimut: {{ this.positionModiconAzimut }}<br/>
                                Zenit: {{ this.positionModiconZenit }}<br/>
                            </div>
                        </b-card-text>
                    </b-card>
                </b-col>
                <b-col>
                    <b-card bg-variant="info" text-variant="white" header="Horaris" class="text-left">
                        <b-card-text>
                            <b-spinner label="Consultant" v-show="this.$store.state.loadingAverages"></b-spinner>
                            <div v-show="!this.$store.state.loadingAverages">
                                Hora: {{ this.currentHour }}<br/>
                                Sortida Sol: {{ this.sunrise }}<br/>
                                Posta Sol: {{ this.sunset }}<br/>
                            </div>
                        </b-card-text>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
        <br/>
        <b-container fluid>
            <div v-if="warningPanels.length>0">
                <h2>Seguidors amb errors de lectura</h2>
                <panels-table :panels="warningPanels"></panels-table>
                <br>
            </div>
            <div v-if="unvalidPanels.length>0">
                <h2>Seguidors amb alertes de validació</h2>
                <panels-table :panels="unvalidPanels"></panels-table>
                <br>
            </div>
            <div>
                <h2>Seguidors sense avisos</h2>
                <panels-table :panels="successPanels"></panels-table>
                <br>
            </div>
        </b-container>
    </div>
</template>

<script>
    import PanelsTable from "../components/PanelsTable"
    import Api from "../api"
    import router from '../router'

    export default {
        name: "DashboardView",
        data: function () {
            return {
                sectors: [],
                successPanels: [],
                unvalidPanels: [],
                warningPanels: [],
                powerLowP1: null,
                powerLowP2: null,
                powerLowP3: null,
                powerHighP1: null,
                powerHighP2: null,
                powerHighP3: null,
                positionEppcAzimut: null,
                positionEppcZenit: null,
                positionModiconAzimut: null,
                positionModiconZenit: null,
                currentHour: null,
                sunrise: null,
                sunset: null,
                onWarningInterval: false,
                onPowerWarningValues: false,
                globalPowerAverage: null,
                minimumPowerAverage: null,
                averagesLoaded: false
            }
        },
        methods: {
            refresh() {
                this.loadPanels()
                this.loadAverages()
            },
            newPanelReadings() {
                this.$store.commit('setLoadingPanels', true)

                Api.newPanelReadings().then(() => {
                    //we must do a refresh if no error
                    this.refresh()
                }).catch(error => {
                    this.$store.commit('setLoadingPanels', false)
                    if (error.response && error.response.status === 401) {
                        //Unauthorized:
                        router.push('/login')
                    }
                })
            },
            loadPanels() {
                this.sectors = []
                this.successPanels = []
                this.unvalidPanels = []
                this.warningPanels = []

                this.$store.commit('setLoadingPanels', true)

                Api.panels().then(response => {
                    //window.console.log(response)
                    this.sectors = response.data.data
                    this.sectors.forEach(sector => {
                        sector.panels.forEach(panel => {
                            //Transformed some numeric values to avoid error
                            //when casting this values on edit panel form.
                            //ToDo: Search a way to disable this conversions and the errors detected on console if disabled
                            panel.latitude = panel.latitude.toFixed(6).toString()
                            panel.longitude = panel.longitude.toFixed(6).toString()
                            panel.power_alert_threshold = panel.power_alert_threshold.toString()
                            panel.power_alarm_threshold = panel.power_alarm_threshold.toString()
                            panel.position_alert_threshold = panel.position_alert_threshold.toString()
                            panel.position_alarm_threshold = panel.position_alarm_threshold.toString()

                            if (panel.position_measurer_params.moverId) {
                                panel.position_measurer_params.moverId = panel.position_measurer_params.moverId.toString()
                            }
                            if (panel.position_measurer_params.port) {
                                panel.position_measurer_params.port = panel.position_measurer_params.port.toString()
                            }
                            if (panel.position_measurer_params.startRegister) {
                                panel.position_measurer_params.startRegister = panel.position_measurer_params.startRegister.toString()
                            }

                            if (panel.power_measurer_params.moverId) {
                                panel.power_measurer_params.moverId = panel.power_measurer_params.moverId.toString()
                            }
                            if (panel.power_measurer_params.port) {
                                panel.power_measurer_params.port = panel.power_measurer_params.port.toString()
                            }


                            if (panel.last_reading.global_status_code !== 'success') {
                                this.warningPanels.push(panel)
                            } else {
                                if (panel.last_reading.failed_validations) {
                                    this.unvalidPanels.push(panel)
                                } else {
                                    this.successPanels.push(panel)
                                }
                            }
                        })
                    })
                }).catch(error => {
                    if (error.response && error.response.status === 401) {
                        //Unauthorized:
                        router.push('/login')
                    }
                }).finally(() => {
                    this.$store.commit('setLoadingPanels', false)
                })
            },
            loadAverages() {
                this.averagesLoaded = false
                this.averages = null
                this.$store.commit('setLoadingAverages', true)

                Api.averages().then(response => {
                    this.averages = response.data
                    this.powerLowP1 = this.averages.power.Low.p1
                    this.powerLowP2 = this.averages.power.Low.p2
                    this.powerLowP3 = this.averages.power.Low.p3
                    this.powerHighP1 = this.averages.power.High.p1
                    this.powerHighP2 = this.averages.power.High.p2
                    this.powerHighP3 = this.averages.power.High.p3
                    this.positionEppcAzimut = this.averages.position.EppcPosition.azimut
                    this.positionEppcZenit = this.averages.position.EppcPosition.zenit
                    this.positionModiconAzimut = this.averages.position.Modicon.azimut
                    this.positionModiconZenit = this.averages.position.Modicon.zenit
                    this.currentHour = this.averages.hours.current
                    this.sunrise = this.averages.hours.sunrise
                    this.sunset = this.averages.hours.sunset
                    this.onWarningInterval = this.averages.notifications.onWarningInterval
                    this.onPowerWarningValues = this.averages.notifications.onPowerWarningValues
                    this.globalPowerAverage = this.averages.notifications.globalPowerAverage
                    this.minimumPowerAverage = this.averages.notifications.minimumPowerAverage
                }).catch(error => {
                    if (error.response && error.response.status === 401) {
                        //Unauthorized:
                        router.push('/login')
                    }
                }).finally(() => {
                    this.$store.commit('setLoadingAverages', false)
                    this.averagesLoaded = true
                })
            }
        },
        created() {
            this.$eventBus.$on('refreshPanels', () => {
                this.refresh()
            })
            this.$eventBus.$on('newPanelReadings', () => {
                this.newPanelReadings()
            })
        },
        mounted() {
            this.refresh()
        },
        beforeDestroy() {
            this.$eventBus.$off('refreshPanels')
            this.$eventBus.$off('newPanelReadings')
        },
        components: {
            'panels-table': PanelsTable,
        }
    }

</script>

<style scoped>

</style>